import { FREE_DELIVERY_MINIMUM_THRESHOLD } from 'common/Constants';
import { ClientEvents } from 'common/events/ClientEvents';
import { formatCurrency } from 'common/FormatUtilities';
import React from 'react';
import { LottieBag, LottiePot, LottieWhisk } from 'src/shared/design-system/Animations';
import { useTrackOnMount } from 'src/shared/hooks/UseTrackOnMount';
import styled from 'styled-components';

const Title: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className='mb-5 text-center text-h3 text-neutral-800'>{children}</div>
);

const Description: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className='mb-5 text-center text-h5 text-neutral-800 [&_b]:font-bold [&_b]:text-radish-100'>{children}</div>
);

const AnimationContainer = styled.div`
  width: 140px;
  height: 140px;
  margin-bottom: 20px;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ExploreLocalShefsStep: React.FC = () => {
  useTrackOnMount(ClientEvents.NEW_USER_EDUCATION_STEP, { step: 'explore-local-shefs' });

  return (
    <Container>
      <AnimationContainer>
        <LottieWhisk />
      </AnimationContainer>
      <Title>Explore local shefs</Title>
      <Description>
        <p>Shef connects you with local, independent shefs in your area.</p>
        <p>
          All shefs are <b>certified cooks</b> and have passed <b>food safety training</b>.
        </p>
      </Description>
    </Container>
  );
};

export const ChooseADeliveryDayStep: React.FC = () => {
  useTrackOnMount(ClientEvents.NEW_USER_EDUCATION_STEP, { step: 'choose-a-delivery-day' });

  return (
    <Container>
      <AnimationContainer>
        <LottieBag />
      </AnimationContainer>
      <Title>Choose a delivery day</Title>
      <Description>
        <p>Shefs need time to find fresh ingredients and cook your meal.</p>
        <p>
          To support this, <b>customers typically order a day or two in advance.</b>
        </p>
      </Description>
    </Container>
  );
};

export const ChooseYourDishesStep: React.FC = () => {
  useTrackOnMount(ClientEvents.NEW_USER_EDUCATION_STEP, { step: 'choose-your-dishes' });

  return (
    <Container>
      <AnimationContainer>
        <LottiePot />
      </AnimationContainer>
      <Title>Choose your dishes</Title>
      <Description>
        <p>You select the dishes you’d like to order. Every dish is prepared fresh.</p>
        <p>
          <b>FREE delivery on orders over {formatCurrency(FREE_DELIVERY_MINIMUM_THRESHOLD, true)}.</b> <br />
          No subscription required.
        </p>
      </Description>
    </Container>
  );
};
